import { useSelector } from "react-redux";
import getCategoryVisualCategories from "../../stores/category/selectors/getCategoryVisualCategories";
import {
  getCategoryBreadcrumbs,
  getCategoryId
} from "../../../../state/modules/category";
import VisualCategories from "./VisualCategories";
import { getLocation } from "../../../../state/modules/router/selectors";

const VisualCategoriesContainer = () => {
  const visualCategories = useSelector(getCategoryVisualCategories);
  const location = useSelector(getLocation);
  const categoryBreadcrumbs = useSelector(getCategoryBreadcrumbs);
  const currentCategoryId = useSelector(getCategoryId);
  const currentPath = location?.pathname;
  const currentSearch = location?.search;

  if (visualCategories.length === 0) {
    return null;
  }

  return (
    <VisualCategories
      visualCategories={visualCategories}
      currentPath={currentPath}
      currentSearch={currentSearch}
      categoryBreadcrumbs={categoryBreadcrumbs}
      currentCategoryId={currentCategoryId}
    />
  );
};

export default VisualCategoriesContainer;
